import type { StateCreatorEnhance } from '@halo/zustand-enhance';
import type { AppStore } from '../main';

export interface WindowStore {
  winDisabled: boolean | undefined;
  winPromise: Promise<boolean>;
  winUrl:
    | {
        pathname: string;
        search: string;
        searchData: Record<string, string>;
        hash: string;
      }
    | undefined;
}

export const windowStoreCreator: StateCreatorEnhance<AppStore> = (set) => {
  const winPromise = new Promise((resolve) => {
    const bc = new BroadcastChannel('chat-window-manager');

    bc.onmessage = (event) => {
      const { type, winUrl } = event.data;
      switch (type) {
        case 'ping':
          bc.postMessage({
            type: 'pong',
          });
          set({ winUrl });
          break;
        case 'pong':
          clearTimeout(timer);
          resolve(true);
          set({ winDisabled: true });
          bc.close();
          break;
      }
    };

    bc.postMessage({
      type: 'ping',
      winUrl: {
        pathname: location.pathname,
        search: location.search,
        searchData: Object.fromEntries(new URLSearchParams(location.search)),
        hash: location.hash,
      },
    });

    const timer = setTimeout(() => {
      resolve(false);
    }, 100);
  });

  return {
    winPromise,
  } as AppStore;
};
